import React from "react";
import { TabEnum } from "./TabsContext";

export interface SavedFilters {
  tab: TabEnum;
  filters: ReadonlyMap<number, readonly string[]>;
}

export interface SelectedFiltersContextValue {
  selectedFiltersRef: React.MutableRefObject<SavedFilters | null>;
}

export const SelectedFiltersContext =
  React.createContext<SelectedFiltersContextValue>(null!);
